import { PopoverOrigin } from '@material-ui/core'
import { SuggestionData } from 'ckeditor5-premium-features'
import { TrackedChange } from 'models/changes'

export interface TrackChangesCardStyles {
    isAdded?: boolean
    suggestionCardFilter?: string
    isNotDefaultSuggestionCardFilter?: boolean
}

export interface ChangeItem {
    id: string
    top: number
    text: string
}

export interface TrackChangesCardProps {
    cardSuggestion: SuggestionData
    trackChanges: TrackedChange | undefined
    isNotDefaultSuggestionCardFilter?: boolean
}

export interface CardType {
    isAdded: boolean
    isReplaced: boolean
    isDeleted: boolean
    isApprovedAdded: boolean
    isApprovedDeleted: boolean
    isRejectedAdded: boolean
    isRejectedDeleted: boolean
    isDisabled?: boolean
    isModified?: boolean
}

export enum Action {
    accept = 'accept',
    discard = 'discard',
    acceptAll = 'acceptAll',
    discardAll = 'discardAll',
}
export interface TrackChangesApiProps {
    trackChangeId: string
    action: Action
}

export interface TrackChangesPanelActionsProps {
    isActionPopoverDisplayed: boolean
    handleActionPopoverClick: () => void
    actionRef: React.RefObject<HTMLButtonElement | null>
}

export interface UseEditorWithSidebarReturn {
    isSidebarVisible: boolean
    toggleSidebar: (expandSidebar?: boolean) => void
}

export interface TrackChangesActionsPopoverProps
    extends TrackChangesPanelActionsProps {
    transformOrigin?: PopoverOrigin
}

export interface UseDebouncedFetchProps {
    fetchFunction?: (resolutionType?: string) => Promise<void>
    processFunction?: (resolutionType?: string) => void
    delay?: number
    setIsLoadingCards?: (isLoadingCards: boolean) => void
}
